import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { currencyFormatter } from '../../utils'

interface ShopCheckoutSideBarPriceOverviewProps {
  formattedPriceNet: string
  formattedShippingCosts: string
  formattedTotalPrice: string
  savingsPrice: number
  onLeavingCheckoutSideBar: () => void
}

const useStyles = makeStyles()(theme => ({
  container: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: 0,
    marginBottom: theme.spacing(3),
    maxHeight: '100%',
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}))

const ShopCheckoutSideBarPriceOverview: React.FC<ShopCheckoutSideBarPriceOverviewProps> = ({
  formattedPriceNet,
  formattedShippingCosts,
  formattedTotalPrice,
  savingsPrice,
  onLeavingCheckoutSideBar,
}) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const formattedSavings = currencyFormatter(savingsPrice)

  return (
    <Box className={classes.container}>
      <Box className={classes.spaceBetween}>
        <Typography marginTop={1} variant="h5">
          {t('shop.checkout-side-bar.sub-total')}
        </Typography>
        <Typography marginTop={1} variant="h4">
          {formattedPriceNet}
        </Typography>
      </Box>
      {savingsPrice !== 0 && (
        <Box className={classes.spaceBetween}>
          <Typography marginTop={1} variant="h5" color="primary">
            {t('shop.shipping-side-bar.price-saved')}
          </Typography>
          <Typography marginTop={1} variant="h4" color="primary">
            {formattedSavings}
          </Typography>
        </Box>
      )}
      <Box className={classes.spaceBetween}>
        <Typography marginTop={1} variant="h5">
          {t('shop.shipping-side-bar.shipping-costs-standart')}
        </Typography>
        <Typography marginTop={1} variant="h4">
          {formattedShippingCosts}
        </Typography>
      </Box>
      <Box className={classes.spaceBetween}>
        <Typography marginTop={4} marginBottom={4} variant="h4" color="primary">
          {t('shop.shipping-side-bar.total')}
        </Typography>
        <Typography marginTop={4} marginBottom={4} variant="h4" color="primary">
          {formattedTotalPrice}
        </Typography>
      </Box>
      <Button
        variant="contained"
        fullWidth
        onClick={() => {
          onLeavingCheckoutSideBar()
        }}
      >
        {t('shop.shipping-side-bar.to-checkout')}
      </Button>
    </Box>
  )
}

export default ShopCheckoutSideBarPriceOverview
